module.exports = __webpack_public_path__ + "media/packs/common/assets/images/fr/illust_registering-d17b2ba0773ca1f487d4c8026f4b3437.png";